var carousel = (function () {

	function setupImageGalleries() {
		let items = document.querySelectorAll('.carousel.gallery');
		items.forEach((el) => {
			let $el = $(el);
			// Set height of any video panels
			$('.vimeo-wrapper', $(el)).css('height', $(el).parent().outerHeight() + 'px');

			// Set height of paging controls
			$('.carousel-controls', $(el)).css('height', $(el).find('.carousel-item.active .info').outerHeight(true) + 'px');

			el.addEventListener('slid.bs.carousel', function (evt) {
				$('.control-counter .current', $el).text(evt.to + 1);
				if ($(el).hasClass('story')) {
					// Stories have their info panels faded in
					$('.story-panel', $el).fadeOut();
					$('.story-panel[data-panel-id=' + evt.to + ']').fadeIn();
				}
			});

			$('.modal-story', $el).on('click', function (evt)
			{
				evt.preventDefault();
				let src = $(this).data('popup');
				$('.story-modal .story-wrapper iframe').prop('src', src);
			});
		});
	}

	function setupMultiplies() {
		let items = document.querySelectorAll('.carousel.multiply .carousel-item');
		items.forEach((el) => {
			const minPerSlide = 3
			let next = el.nextElementSibling
			for (var i = 1; i < minPerSlide; i++) {
				if (!next) {
					// wrap carousel by using first child
					next = items[0]
				}
				let cloneChild = next.cloneNode(true)
				el.appendChild(cloneChild.children[0])
				next = next.nextElementSibling
			}
		});
	}

	function setupImageSliders() {
		let carousels = document.querySelectorAll('.carousel.image-slider');
		carousels.forEach((c) => {
			let numSlides = $('.carousel-item', c).length;
			let pct = 100 / numSlides;
			$('.carousel-indicator .bar', c).css('width', pct + '%');

			c.addEventListener('slide.bs.carousel', function (evt) {
				$('.carousel-indicator .bar', c).css('left', (evt.to * pct) + '%');
			});
		});
	}

	return {
		init: function () {
			$(function () {
				setupImageGalleries();
				setupMultiplies();
				setupImageSliders();
			});
		}
	};
})();

export var carousel;